import { ThemeProvider } from '@chakra-ui/core'

import { Theme } from '../../theme'

export interface ThemeProviderProps {
  theme: Theme
}

export { ThemeProvider }

export default ThemeProvider
